const restaurant = {
  restaurant: "מִסעָדָה", // translated
  restaurants: "מסעדות", // translated
  category: "קטגוריה", // translated
  score: "ציון", // translated
  priceQuartile: "רבעון מחיר", // translated
  scoreLowestFirst: "ציון (הנמוך ביותר ראשון)", // translated
  scoreHighestFirst: "ציון (הגבוה ביותר ראשון)", // translated
  priceLowestFirst: "מחיר מהנמוך לגבוה)", // translated
  priceHighestFirst: "המחיר (הגבוה ביותר ראשון)", // translated
  allPrices: "כל המחירים", // translated
  reserve: "לְהַזמִין", // translated
  dining: "אוכל", // translated
};

export default restaurant;
